export default __webpack_public_path__ + "static/media/s1.15bfe37e.jpg";